module.exports = __webpack_public_path__ + "./img/Spear_v06_SpearOutline.5b2b74e89ac5cb5706cd42b6515c63bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SpearGauge/images/Spear_v06_SpearOutline.png
// module id = ./src/components/SpearGauge/images/Spear_v06_SpearOutline.png
// module chunks = 0